import { ibanFormatter } from '@asn/formatters';

import { Pipe, PipeTransform } from '@angular/core';

/**
 * @ngdoc pipe
 *
 * @name apIban
 *
 * @description
 *
 **/
@Pipe({ name: 'apIban', standalone: true })
export class ApIbanPipe implements PipeTransform {
    transform(iban: string): string {
        return ibanFormatter.formatDisplay(iban);
    }
}
